<div class="breadcumb-wrapper d-flex">
  <app-breadcumb-item [activePath]="breadcrumbItem.parent?.routerLink"></app-breadcumb-item>
  <app-breadcumb-item [activePath]="breadcrumbItem.current?.routerLink" *ngIf="hasMoreThanOneMenuLevel2()"></app-breadcumb-item>
  <app-breadcumb-item [activePath]="breadcrumbItem.child?.routerLink" [isLastInBreadcumb]="true" *ngIf="hasMoreThanOneTab()"></app-breadcumb-item>
</div>
